/**
* @description: 自助营业收入报表
* @author: chy
*/
<template>
	<div class="balance-report">
		<div class="balance-list">
			<el-form :inline="true" size="small" :model="list_form">
				<el-form-item label="时间">
					<div class="clearfix" ref="list_date">
						<el-col :span="11">
							<el-input placeholder="开始时间" v-model="list_form.start_time"></el-input>
						</el-col>
						<el-col class="el-line" :span="2">-</el-col>
						<el-col :span="11">
							<el-input placeholder="结束时间" v-model="list_form.end_time"></el-input>
						</el-col>
					</div>
				</el-form-item>
				<el-form-item label="门店">
					<el-select v-model="list_form.shop_id" filterable placeholder="请选择门店" @change="changeShop($event)">
						<el-option v-for="item in shop_list" :key="item.id" :label="item.name"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="类型">
					<el-select v-model="list_form.order_type" filterable placeholder="请选择类型">
						<el-option v-for="item in order_type_list" :key="item.order_type" :label="item.order_type_name"
							:value="item.order_type"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="运营场景">
					<el-select v-model="list_form.operational_scene" filterable placeholder="请选择运营场景">
						<el-option v-for="item in operational_scene_list" :key="item.operational_scene"
							:label="item.operational_scene_name" :value="item.operational_scene"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="订单号">
					<el-input placeholder="请输入订单号" v-model.trim="list_form.order_id" clearable></el-input>
				</el-form-item>
				<el-form-item label="支付方式">
					<el-select v-model="list_form.pay_platform" filterable placeholder="请选择支付方式">
						<el-option v-for="item in pay_platform_list" :key="item.pay_platform"
							:label="item.pay_platform_name" :value="item.pay_platform"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="listQuery">查询</el-button>
					<el-button @click="listExport">导出</el-button>
				</el-form-item>
			</el-form>
			<div class="total-income">
				总收入：{{ total_income }}
			</div>
			<el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
				element-loading-background="rgba(0, 0, 0, 0.6)" :header-cell-style="{ 'text-align': 'center' }"
				:cell-style="{ 'text-align': 'center' }" max-height="650" :data="list_table">
				<el-table-column type="index" width="50" label="序号">
				</el-table-column>
				<el-table-column :prop="item.key" :label="item.name" v-for="item in column_arr" :key="item.key"
					:min-width="item.min_width ? item.min_width : '110px'">
				</el-table-column>
				<el-table-column label="预订详情"  >
					<template slot-scope="scope">
						<el-button type="primary" v-if="isShowDetails(scope.row)" @click="lookDetails(scope.row)"
							size="small">详情</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background layout="total, prev, pager, next, jumper" :page-size="page_size"
				:current-page.sync="list_page" :total="list_total" @current-change="getList">
			</el-pagination>

			<el-dialog :visible.sync="showLookDetailDialog" width="450px" :before-close="handleClose">
				<div slot="title" style="font-size: 18px; border-bottom: 1px solid #e5e5e5; padding-bottom: 10px;">
				预订详情
				</div>
				<div class="detail-box">
					<div class="detail-item">
						<div class="item-title">预订单号：</div>
						<div class="item-content">{{ detail_info.book_order_id }}</div>
					</div>
					<div class="detail-item">
						<div class="item-title">预订门店：</div>
						<div class="item-content">{{ detail_info.shop_name }}</div>
					</div>
					<div class="detail-item">
						<div class="item-title">预约包厢：</div>
						<div class="item-content">{{ detail_info.room_name }}</div>
					</div>
					<div class="detail-item">
						<div class="item-title">开始时间：</div>
						<div class="item-content">{{ detail_info.start_time }}</div>
					</div>
					<div class="detail-item">
						<div class="item-title">结束时间：</div>
						<div class="item-content">{{ detail_info.end_time }}</div>
					</div>
					<div class="detail-item">
						<div class="item-title">消费时长：</div>
						<div class="item-content">{{ detail_info.time_str }}</div>
					</div>
					<div class="detail-item">
						<div class="item-title">客户昵称：</div>
						<div class="item-content">{{ detail_info.user_name }}</div>
					</div>
				</div>
			</el-dialog>
		</div>
	</div>
</template>
<script>
import Vue from "vue";
export default {
	name: "operating-revenue-report",
	data() {
		return {
			loading: false, //表格加载状态
			list_form: {
				start_time: "", //开始时间
				end_time: "", //结束时间
				shop_id: "", //门店id
				order_type: "", //类型
				pay_platform: "", //支付方式
				operational_scene: "", //运行场景
				order_id: "", //订单id
				order_by: "business_date_desc", // 排序，business_date_asc：日期正序，business_date_desc：日期倒序
			},
			shop_list: [], //门店列表
			order_type_list: [], //类型
			pay_platform_list: [], //支付方式
			operational_scene_list: [], //运行场景
			list_table: [], //表格数据
			list_page: 1,//当前页码
			list_total: 0,//总页数
			page_size: 10,//每页条数
			total_income: 0, //总收入
			showLookDetailDialog: false, // 预订详情弹窗
			detail_info: {}, // 预订详情
			column_arr: [
				{
					key: "order_id",
					name: "订单号",
				},
				{
					key: "create_time",
					name: "时间",
				},
				{
					key: "title",
					name: "套餐名称",
					min_width: "200px",
				},
				{
					key: "user_name",
					name: "用户信息",
				},
				{
					key: "order_type_name",
					name: "类型",
				},
				{
					key: "operational_scene_name",
					name: "运营场景",
				},
				{
					key: "amount",
					name: "付款金额",
				},
				{
					key: "pay_platform_name",
					name: "支付方式",
				},
			],
		};
	},
	mounted: function () {
		this.list_form.start_time = moment().format("YYYY-MM-DD 08:00");
		this.list_form.end_time = moment().add(1, "day").format("YYYY-MM-DD 08:00");
		this.innitDate();
		new Promise((resolve) => {
			this.getShop(resolve);
		}).then((res) => {
			this.list_form.shop_id = this.shop_list[0].id;
			this.initType(this.list_form.shop_id);
		});
	},
	methods: {
		// 初始化日期插件
		innitDate: function () {
			const _this = this;
			$(_this.$refs.list_date).daterangepicker(
				{
					buttonClasses: ["btn btn-default"],
					applyClass: "btn-small btn-orange",
					cancelClass: "btn-small btn-gray",
					startDate: moment().toDate(),
					endDate: moment().add(1, "day").toDate(),
				},
				function (start, end, label) {
					_this.list_form.start_time = start.format("YYYY-MM-DD 08:00");
					_this.list_form.end_time = end.format("YYYY-MM-DD 08:00");
				}
			);
		},
		// 初始化门店输入框
		getShop: function (resolve) {
			const _this = this;
			Vue.axios
				.post("PublicData/api_getShopListByPurview", {
					header: Vue.request_header,
					request: {
						version: Vue.version,
						param: {},
					},
					comment: "",
				})
				.then((res) => {
					if (res.data.response.result_code == "true") {
						_this.shop_list = res.data.response.result;
						_this.shop_list.shift();
						resolve();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch((err) => {
					layer.msg("门店出错啦");
				});
		},
		// 门店选择框change事件
		changeShop: function (id) {
			// console.log(e);
			this.initType(id);
			this.list_form.operational_scene = "";
			this.list_form.order_id = "";
		},
		// 初始化类型和运行场景
		initType: function (shopId) {
			// console.log("id", shopId);
			Vue.axios
				.post("CommunityShop/getCommunityRevenuesSearchParams", {
					header: Vue.request_header,
					request: {
						version: Vue.version,
						param: { shop_id: shopId },
					},
					comment: "",
				})
				.then((res) => {
					this.order_type_list = res.data.response.result.order_type_list;
					this.pay_platform_list = res.data.response.result.pay_platform_list;
					this.operational_scene_list = res.data.response.result.operational_scene_list;
					this.initSelectAll();
				})
				.catch((err) => {
					layer.msg("类型出错啦");
				});
		},
		// 初始化全部选项
		initSelectAll: function () {
			this.order_type_list.unshift(
				{
					order_type: "",
					order_type_name: "全部",
				}
			);
			this.pay_platform_list.unshift(
				{
					pay_platform: "",
					pay_platform_name: "全部",
				}
			);
			this.operational_scene_list.unshift(
				{
					operational_scene: "",
					operational_scene_name: "全部",
				}
			);
			//this.getList(1)

		},
		// 列表查询
		listQuery: function () {
			this.list_page = 1
			this.getList(this.list_page);
		},
		// 列表导出
		listExport: function () {
			window.location.href = Vue.ctUrl + 'CommunityShop/CommunityRevenuesExport' +
				"?start_time=" + this.list_form.start_time +
				"&end_time=" + this.list_form.end_time +
				"&shop_id=" + this.list_form.shop_id +
				"&order_type=" + this.list_form.order_type +
				"&pay_platform=" + this.list_form.pay_platform +
				"&operational_scene=" + this.list_form.operational_scene +
				"&order_id=" + this.list_form.order_id +
				"&page=" + this.list_page +
				"&page_size=" + this.page_size;
			layer.msg("导出成功！");
		},
		//获取列表
		getList: function (page) {
			const _this = this;
			_this.loading = true;
			_this.list_page = page
			Vue.axios.post("CommunityShop/getCommunityRevenuesList", {
				"header": Vue.request_header,
				"request": {
					"version": Vue.version,
					'param': {
						'page': page,
						'page_size': _this.page_size,
						'start_time': _this.list_form.start_time,
						'end_time': _this.list_form.end_time,
						'shop_id': _this.list_form.shop_id,
						'order_type': _this.list_form.order_type,
						'pay_platform': _this.list_form.pay_platform,
						'operational_scene': _this.list_form.operational_scene,
						'order_id': _this.list_form.order_id,
					}
				},
				"comment": ""

			})
				.then((res) => {
					if (page == 1) {
						_this.list_total = Number(res.data.response.result.count)
						_this.total_income = Number(res.data.response.result.total_amount) || 0
					}
					_this.list_table = res.data.response.result.data;
					_this.loading = false;
				})
		},
		// 查看详细
		lookDetails(row) {
			this.showLookDetailDialog = true;
			this.detail_info = row.book_info;
		},
		// 关闭详细弹窗
		handleClose() {
			this.showLookDetailDialog = false;
			this.detail_info = {}
		},
		// 判断是否显示详情按钮
		isShowDetails(row) {
			if (row.book_info.length == 0) {
				return false;;
			} else {
				if (typeof row.book_info == "object") {
					return true;
				} else {
					return false;
				}
				return false;
			}
		},
	},
};
</script>
<style lang="less" scoped>
.total-income {
	font-weight: bold;
}

.detail-box {
	.detail-item {
		font-size: 18px;
		margin-bottom: 5px;
		display: flex;

		.item-title {
			flex: 1;
		}

		.item-content {
			flex: 3;
		}
	}
}
</style>